import React, { useEffect, useRef, useState } from "react";

const API_BASE = process.env.REACT_APP_NAV_API || "http://localhost:8080";

function fmtDate(d) {
  if (!d) return "";
  // BigQuery DATE may arrive as "2026-03-02" or object; handle both
  const s = typeof d === "string" ? d : d.value || "";
  const dt = new Date(s);
  if (isNaN(dt.getTime())) return s;
  return dt.toLocaleDateString("en-GB"); // dd/mm/yyyy
}
function typeMeta(type) {
  const t = String(type || "").toUpperCase();

  if (t === "FEATURE_LAUNCH") {
    return { label: "Feature Launch", icon: "⚡" };
  }

  if (t === "PROCESS_UPDATE") {
    return { label: "Process Update", icon: "🔄" };
  }

  if (t === "TRAINING_ANNOUNCEMENT") {
    return { label: "Training", icon: "🎓" };
  }

  if (t === "POLICY_CHANGE") {
    return { label: "Policy Change", icon: "📜" };
  }

  if (t === "CIRCULAR") {
    return { label: "Circular", icon: "📢" };
  }

  return { label: t || "Announcement", icon: "📢" };
}
export default function WhatsNewSection({ activeDoerEmail, activeDoerName }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedIds, setExpandedIds] = useState({});
  const sectionRef = useRef(null);
  const hasMarkedSeenRef = useRef(false);

  async function load() {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/whatsnew/list?limit=20`, {
  method: "GET",
  credentials: "include", // ✅ add
});
      const json = await res.json();
      setItems(json.items || []);
    } catch (e) {
      console.error("WhatsNew load error", e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
  }, []);

  // When section becomes visible → logOpen + markSeen (once)
  useEffect(() => {
    if (!sectionRef.current) return;

    const io = new IntersectionObserver(
      (entries) => {
        const visible = entries?.[0]?.isIntersecting;
        if (!visible) return;
        if (hasMarkedSeenRef.current) return;
        hasMarkedSeenRef.current = true;

        if (!activeDoerEmail) return;
        const firstItemId = items?.[0]?.id || null;

       fetch(`${API_BASE}/whatsnew/logOpen`, {
  method: "POST",
  credentials: "include", // ✅ add
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    email: activeDoerEmail,
    name: activeDoerName || null,
    source: "SECTION_SCROLL",
    itemId: firstItemId,
  }),
}).catch(() => {});

fetch(`${API_BASE}/whatsnew/markSeen`, {
  method: "POST",
  credentials: "include", // ✅ add
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ email: activeDoerEmail }),
}).catch(() => {});
      },
      { threshold: 0.25 }
    );

    io.observe(sectionRef.current);
    return () => io.disconnect();
  }, [activeDoerEmail, activeDoerName, items]);

return (
  <div ref={sectionRef} id="whats-new-section" className="whatsNewContainer">
    
    {/* 🔥 STYLE BLOCK */}
    <style>{`
      .whatsNewContainer {
        margin: 10px ;
        background: #f4f6fb;
        border-radius: 12px;
        // border: 1px solid rgba(0,0,0,0.05);
      }

      .whatsNewHeader {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 0px;
      }

      .whatsNewTitle {
        font-size: 18px;
        font-weight: 800;
        color: #1b1f3b;
      }

.cardsGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;
}

      .card {
        background: #ffffff;
        border-radius: 14px;
        padding: 12px;
        border: 1px solid rgba(0,0,0,0.06);
        transition: all 0.25s ease;
        cursor: pointer;
      }

      .card:hover {
        transform: translateY(-4px);
        box-shadow: 0 6px 18px rgba(0,0,0,0.08);
      }

      .tag {
        font-size: 11px;
        font-weight: 700;
        padding: 4px 10px;
        // border-radius: 19px;
        display: inline-flex;
        align-items: center;
        gap: 6px;
      }

.tag.feature_launch {
  background: #fff3e6;
  color: #ff7a00;
}
.tag.feature {
  background: #fff3e6;
  color: #ff7a00;
}
.tag.process_update {
  background: #e8f0ff;
  color: #2b5cff;
}

.tag.training_announcement {
  background: #eefbf3;
  color: #15803d;
}

.tag.policy_change {
  background: #fff1f2;
  color: #be123c;
}

.tag.circular {
  background: #f3e8ff;
  color: #7c3aed;
}

      .date {
        font-size: 11px;
        color: #707276;
        margin-left: auto;
      }

      .cardHeader {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
      }

      .title {
        font-size: 13px;
        font-weight: 700;
        color: #1b1f3b;
        margin-bottom: 6px;
      }

.desc {
  font-size: 11px;
  color: #5f6b7a;
  line-height: 1.5;

  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* when expanded */
.desc.expanded {
  -webkit-line-clamp: unset;
  display: block;
}

.viewMore {
  display: inline-block;
  margin-top: 6px;
  font-size: 11px;
  font-weight: 600;
  color: #2b5cff;
  cursor: pointer;
}

.viewMore:hover {
  text-decoration: underline;
}
      .link {
        margin-top: 10px;
        font-size: 13px;
        font-weight: 600;
        color: #2b5cff;
        text-decoration: none;
      }

      .link:hover {
        text-decoration: underline;
      }
    `}</style>

    {/* HEADER */}
    <div className="whatsNewHeader">
      <div className="whatsNewTitle">✨ What's New</div>
      {loading && <div className="date">Loading...</div>}
    </div>

    {/* CARDS */}
    <div className="cardsGrid">
      {items.map((it) => {
        const meta = typeMeta(it.type);
       const typeClass = String(it.type || "").toLowerCase();

        return (
          <div key={it.id} className="card">
            
            <div className="cardHeader">
              <div className={`tag ${typeClass}`}>
                {meta.icon} {meta.label}
              </div>
              <div className="date">{fmtDate(it.event_date)}</div>
            </div>

            <div className="title">{it.title}</div>
            <div className={`desc ${expandedIds[it.id] ? "expanded" : ""}`}>
             {it.description}
           </div>
           
           {it.description && it.description.length > 120 && (
             <span
               className="viewMore"
               onClick={() =>
                 setExpandedIds((prev) => ({
                   ...prev,
                   [it.id]: !prev[it.id],
                 }))
               }
             >
               {expandedIds[it.id] ? "View Less" : "View More"}
             </span>
           )}

            {it.link_url && (
              <a
                href={it.link_url}
                target="_blank"
                rel="noreferrer"
                className="link"
                onClick={() => {
                  if (!activeDoerEmail) return;

                  fetch(`${API_BASE}/whatsnew/logOpen`, {
  method: "POST",
  credentials: "include", // ✅ add
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    email: activeDoerEmail,
    name: activeDoerName || null,
    source: "POST_CLICK",
    itemId: it.id,
  }),
}).catch(() => {});
                }}
              >
                Open Link →
              </a>
            )}
          </div>
        );
      })}
    </div>


    {!loading && items.length === 0 && (
      <div className="date">No updates yet.</div>
    )}
  </div>
);
}